import {BrowserModule} from '@angular/platform-browser';
import {HTTP_INTERCEPTORS, HttpClientModule} from "@angular/common/http";
//import "froala-editor/js/froala_editor.pkgd.min.js";
import "froala-editor/js/plugins/inline_style.min.js";
import "froala-editor/js/plugins/inline_class.min.js";
import "froala-editor/js/plugins/char_counter.min.js";
import "froala-editor/js/plugins/font_size.min.js";
import "froala-editor/js/plugins/align.min.js";
import "froala-editor/js/plugins/quote.min.js";
import "froala-editor/js/plugins/fullscreen.min.js";
import "froala-editor/js/plugins/special_characters.min.js";
import "froala-editor/js/third_party/font_awesome.min.js";
import "froala-editor/js/languages/pt_br.js";
import {FroalaEditorModule, FroalaViewModule} from 'angular-froala-wysiwyg';

import {NgModule, ErrorHandler, Injectable, Injector} from '@angular/core';
import {IonicApp, IonicModule, IonicErrorHandler, Platform} from 'ionic-angular';

import {Pro} from "@ionic/pro";

import {Device} from '@ionic-native/device';
import {StatusBar} from '@ionic-native/status-bar';
import {SplashScreen} from '@ionic-native/splash-screen';
import {Push} from '@ionic-native/push';
import {Facebook} from '@ionic-native/facebook';
import {Contacts} from "@ionic-native/contacts";
import {Camera} from '@ionic-native/camera';
import {Ndef, NFC} from "@ionic-native/nfc";
import {File} from '@ionic-native/file';
import {FileTransferObject} from '@ionic-native/file-transfer';
//import {FileTransfer, FileUploadOptions, FileTransferObject} from '@ionic-native/file-transfer';
import {WebIntent} from '@ionic-native/web-intent';
//import {InAppBrowser, AppAvailability} from '@ionic-native/in-app-browser';
import {InAppBrowser} from '@ionic-native/in-app-browser';
import {ImagePicker} from "@ionic-native/image-picker";
import {TapticEngine} from '@ionic-native/taptic-engine';
import {Vibration} from "@ionic-native/vibration";
import {CallNumber} from "@ionic-native/call-number";
import {NetworkInterface} from "@ionic-native/network-interface";
import {LaunchNavigator} from "@ionic-native/launch-navigator";
import {BarcodeScanner} from "@ionic-native/barcode-scanner";
import {WheelSelector} from '@ionic-native/wheel-selector';
import {Clipboard} from "@ionic-native/clipboard";
import {SocialSharing} from "@ionic-native/social-sharing";

import {ScreenOrientation} from '@ionic-native/screen-orientation';
import {Keyboard} from '@ionic-native/keyboard';
import {AppVersion} from '@ionic-native/app-version';
import {IonicStorageModule} from '@ionic/storage';
import {Geolocation} from "@ionic-native/geolocation";
import {OpenNativeSettings} from '@ionic-native/open-native-settings';  //IONIC4 - @ionic-native/open-native-settings/ngx
import {YoutubeVideoPlayer} from '@ionic-native/youtube-video-player';
import {Deeplinks} from "@ionic-native/deeplinks";

import {Util} from './util';

import {HandappMain} from './handapp-main/handapp-main';

import {LogadoService} from '../providers/logado-service';
import {CarbookService} from '../providers/carbook-service';
import {DataService} from '../providers/data-service';
import {MessageService} from '../providers/message-service';
import {StorageService} from "../providers/storage-service";
import {GeolocationService} from "../providers/geolocation-service";
import {PushService} from "../providers/push-service";

import {NavRepository} from "../repositories/nav-repository";

import {BridgeInterceptor} from "../interceptors/bridge-interceptor";
import {HttpService} from "../providers/http-service";

import {ImageCropperModule} from "ng2-img-cropper";
import {FacebookModule} from 'ngx-facebook';
import {YoutubePlayerModule} from 'ngx-youtube-player';
import {BrMaskerModule} from 'brmasker-ionic-3';
import {RoundProgressModule} from "angular-svg-round-progressbar";
import {DeviceDetectorModule} from 'ngx-device-detector';

import {BadgeDirective} from '../directives/badge';
import {BlinkBgDirective} from '../directives/blink-bg';
import {BlscrollDirective} from '../directives/blscroll';
import {BrMaskDirective} from "../directives/brmasker"; // ## NAO ESTA USANDO ## //
import {ConviteHoverDirective} from '../directives/convite-hover';
import {CorbackDirective} from "../directives/corback";
import {CormainDirective} from "../directives/cormain";
import {DebouncedDirective} from '../directives/debounced';
import {DelayIonChangeDirective} from '../directives/delay-ion-change';
import {HideHeaderDirective} from '../directives/hide-header';
import {HotkeyDirective} from '../directives/hotkey';
import {KeyboardAttachDirective} from "../directives/keyboard-attach";
import {ModalMarginDirective} from '../directives/modal-margin';
import {MolderDirective} from "../directives/molder";
import {OverslideDirective} from '../directives/overslide';
import {RequestButtonDirective} from '../directives/request-button';
import {TextareaAutoresizeDirective} from '../directives/textarea-autoresize';
import {VerMaisDirective} from "../directives/ver-mais";
import {WebsterDirective} from "../directives/webster";
import {WriterDirective} from '../directives/writer';

import {BarcodePipe} from '../pipes/barcode/barcode';
import {CurrencyPipe} from '../pipes/currency/currency';
import {DatetimePipe} from '../pipes/datetime/datetime';
import {DatenewPipe} from '../pipes/datenew/datenew';
import {HourtimePipe} from '../pipes/hourtime/hourtime';
import {DinheiroPipe} from '../pipes/dinheiro/dinheiro';
import {NumericoPipe} from '../pipes/numerico/numerico';
import {AbsolutePipe} from '../pipes/numerico/numerico';
import {PorcentaPipe} from '../pipes/porcenta/porcenta';
import {FilterFieldPipe} from '../pipes/filter-field/filter-field';
import {FilterIndexPipe} from '../pipes/filter-index/filter-index';
import {FilterValuePipe} from '../pipes/filter-value/filter-value';

import {TabsPage} from '../pages/both/tabs/tabs';

import {TabMenu} from '../components/tab-menu/tab-menu';
import {AppConvite} from "../components/app-convite/app-convite";
import {AppTeclado} from "../components/app-teclado/app-teclado";
import {ContentDrawer} from '../components/content-drawer/content-drawer';
import {DragButton} from '../components/drag-button/drag-button';
import {Backfull} from '../components/backfull/backfull';
import {AppFeedback} from '../components/app-feedback/app-feedback';
import {Loading} from '../components/loading/loading';
import {CanalText} from '../components/canal-text/canal-text';
import {ImageScroll} from "../components/image-scroll/image-scroll";
import {AppPayout} from "../components/app-payout/app-payout";
import {AppMeritum} from "../components/app-meritum/app-meritum";
import {AppPlastic} from "../components/app-plastic/app-plastic";
import {Webster} from "../components/webster/webster";
import {TimePicker} from "../components/time-picker/time-picker";
import {DatePicker} from "../components/date-picker/date-picker";
import {Player} from "../components/player/player";
import {Searched} from "../components/searched/searched";
import {SpotusAnime} from "../components/spotus-anime/spotus-anime";

import {ShowbookPage} from '../pages/show/showbook/showbook';
import {ShowopenPage} from '../pages/show/showopen/showopen';
import {ShowsyncPage} from '../pages/show/showsync/showsync';
import {ShowdeskPage} from '../pages/show/showdesk/showdesk';
import {ShowfilaPage} from '../pages/show/showfila/showfila';
import {ShowtalkPage} from '../pages/show/showtalk/showtalk';
import {ShowhourPage} from '../pages/show/showhour/showhour';
import {ShowtimePage} from '../pages/show/showtime/showtime';
import {ShowviewPage} from '../pages/show/showview/showview';
import {ShowviewAtracaoPage} from '../pages/show/showview-atracao/showview-atracao';
import {ShowviewListaPage} from '../pages/show/showview-lista/showview-lista';

import {LoadingErroPage} from '../pages/sync/loading-erro/loading-erro';

import {PrivacyMenuPage} from '../pages/sync/privacy-menu/privacy-menu';
import {ProfileAuthPage} from '../pages/sync/profile-auth/profile-auth';
import {ProfileMenuPage} from '../pages/sync/profile-menu/profile-menu';
import {ProfileFotoPage} from '../pages/sync/profile-foto/profile-foto';
import {ProfilePagePage} from '../pages/sync/profile-page/profile-page';
import {ProfileBornPage} from "../pages/sync/profile-born/profile-born";
import {ProfileShipPage} from '../pages/sync/profile-ship/profile-ship';
import {MedalhaMenuPage} from '../pages/sync/medalha-menu/medalha-menu';

import {FriendyMenuPage} from "../pages/sync/friendy-menu/friendy-menu";
import {VisitorMenuPage} from "../pages/sync/visitor-menu/visitor-menu";
import {CentralMenuPage} from "../pages/sync/central-menu/central-menu";
import {ContatoMenuPage} from "../pages/sync/contato-menu/contato-menu";
import {AddressMenuPage} from '../pages/sync/address-menu/address-menu';
import {AccountMenuPage} from '../pages/sync/account-menu/account-menu';
import {EmissorMenuPage} from '../pages/sync/emissor-menu/emissor-menu';
import {DevelopMenuPage} from '../pages/sync/develop-menu/develop-menu';
import {ConexaoMenuPage} from '../pages/sync/conexao-menu/conexao-menu';

import {CheckinMenuPage} from '../pages/sync/checkin-menu/checkin-menu';
import {EntrakiOpenPage} from '../pages/sync/entraki-open/entraki-open';
import {RolezinMenuPage} from '../pages/sync/rolezin-menu/rolezin-menu';
import {PublicoMenuPage} from '../pages/sync/publico-menu/publico-menu';
import {RetirarMenuPage} from '../pages/sync/retirar-menu/retirar-menu';

import {MachineMenuPage} from '../pages/sync/machine-menu/machine-menu';

import {MonitorDeskPage} from '../pages/sync/monitor-desk/monitor-desk';
import {RegeditMenuPage} from '../pages/sync/regedit-menu/regedit-menu';
import {DesktopMenuPage} from '../pages/sync/desktop-menu/desktop-menu';

import {LancakiMenuPage} from '../pages/sync/lancaki-menu/lancaki-menu';
import {ConsumoSalePage} from '../pages/sync/consumo-sale/consumo-sale';
import {ConsumoEditPage} from '../pages/sync/consumo-edit/consumo-edit';
import {ContabyMenuPage} from '../pages/sync/contaby-menu/contaby-menu';
import {ChavecoMenuPage} from '../pages/sync/chaveco-menu/chaveco-menu';
import {SupportMenuPage} from '../pages/sync/support-menu/support-menu';

import {NegocioMenuPage} from "../pages/sync/negocio-menu/negocio-menu";
import {WebstorOpenPage} from "../pages/sync/webstor-open/webstor-open";
import {WebstorMenuPage} from "../pages/sync/webstor-menu/webstor-menu";
import {SettingMenuPage} from "../pages/sync/setting-menu/setting-menu";
import {ClusterMenuPage} from "../pages/sync/cluster-menu/cluster-menu";
import {BrandedMenuPage} from "../pages/sync/branded-menu/branded-menu";
import {BrandedHtmlPage} from '../pages/sync/branded-html/branded-html';
import {BlendedMenuPage} from "../pages/sync/blended-menu/blended-menu";
import {GateweyMenuPage} from '../pages/sync/gatewey-menu/gatewey-menu';
import {MeritumMenuPage} from "../pages/sync/meritum-menu/meritum-menu";

import {HotspotMenuPage} from '../pages/sync/hotspot-menu/hotspot-menu';
import {HotspotWorkPage} from "../pages/sync/hotspot-work/hotspot-work";
import {HotspotMarkPage} from "../pages/sync/hotspot-mark/hotspot-mark";
import {HotspotLovePage} from '../pages/sync/hotspot-love/hotspot-love';

import {GeradorMenuPage} from '../pages/sync/gerador-menu/gerador-menu';
import {FinanceMenuPage} from "../pages/sync/finance-menu/finance-menu";
import {InvoiceMenuPage} from "../pages/sync/invoice-menu/invoice-menu";
import {PaybookFindPage} from '../pages/sync/paybook-find/paybook-find';
import {PaybookMenuPage} from '../pages/sync/paybook-menu/paybook-menu';
import {PaybookCartPage} from '../pages/sync/paybook-cart/paybook-cart';
import {ParcelaMenuPage} from '../pages/sync/parcela-menu/parcela-menu';
import {PaymentMenuPage} from '../pages/sync/payment-menu/payment-menu';
import {MethodoMenuPage} from '../pages/sync/methodo-menu/methodo-menu';
import {RepasseMenuPage} from '../pages/sync/repasse-menu/repasse-menu';
import {PlasticMenuPage} from '../pages/sync/plastic-menu/plastic-menu';
import {CashierMenuPage} from "../pages/sync/cashier-menu/cashier-menu";
import {ProdutoMenuPage} from '../pages/sync/produto-menu/produto-menu';
import {ProdutoViewPage} from '../pages/sync/produto-view/produto-view';

import {WorkdayCodePage} from "../pages/sync/workday-code/workday-code";
import {SpotdayListPage} from '../pages/sync/spotday-list/spotday-list';
import {SpotdayInfoPage} from "../pages/sync/spotday-info/spotday-info";
import {SpotdayViewPage} from "../pages/sync/spotday-view/spotday-view";
import {ConviteMenuPage} from '../pages/sync/convite-menu/convite-menu';

import {UnidadeMenuPage} from '../pages/sync/unidade-menu/unidade-menu';
import {UsuarioMenuPage} from '../pages/sync/usuario-menu/usuario-menu';
import {GaleriaMenuPage} from "../pages/sync/galeria-menu/galeria-menu";

import {VoucherInfoPage} from '../pages/sync/voucher-info/voucher-info';

import {ModalActionPage} from "../pages/sync/modal-action/modal-action";
import {ModalFieldPage} from "../pages/sync/modal-field/modal-field";
import {ListingMenuPage} from '../pages/sync/listing-menu/listing-menu';

import {WebsiteSpotPage} from '../pages/sync/website-spot/website-spot';
import {WebsiteOlhaPage} from '../pages/sync/website-olha/website-olha';
import {WebstorSetaPage} from '../pages/sync/webstor-seta/webstor-seta';
import {WebstorEventoTipoPage} from '../pages/sync/webstor-evento-tipo/webstor-evento-tipo';
import {WarningMenuPage} from '../pages/sync/warning-menu/warning-menu';

import {CpBlocki} from '../pages/sync/website-spot/components/cp-blocki/cp-blocki';
import {CpButton} from '../pages/sync/website-spot/components/cp-button/cp-button';
import {CpEntire} from '../pages/sync/website-spot/components/cp-entire/cp-entire';
import {CpHeader} from '../pages/sync/website-spot/components/cp-header/cp-header';
import {CpValued} from '../pages/sync/website-spot/components/cp-valued/cp-valued';
import {CpGround} from '../pages/sync/website-spot/components/cp-ground/cp-ground';

import {CpHistory} from '../pages/sync/website-spot/components/cp-history/cp-history';
import {CpLogotipo} from '../pages/sync/website-spot/components/cp-logotipo/cp-logotipo';

import {HcAction} from '../pages/sync/website-spot/components/hc-action/hc-action';
import {HcAddress} from '../pages/sync/website-spot/components/hc-address/hc-address';
import {HcBanner} from '../pages/sync/website-spot/components/hc-banner/hc-banner';
import {HcSocial} from '../pages/sync/website-spot/components/hc-social/hc-social';
import {HcCheckin} from '../pages/sync/website-spot/components/hc-checkin/hc-checkin';
import {HcBirthday} from '../pages/sync/website-spot/components/hc-birthday/hc-birthday';
import {HcBranded} from '../pages/sync/website-spot/components/hc-branded/hc-branded';
import {HcDelivery} from '../pages/sync/website-spot/components/hc-delivery/hc-delivery';
import {HcVoucher} from '../pages/sync/website-spot/components/hc-voucher/hc-voucher';
import {HcEvento} from '../pages/sync/website-spot/components/hc-evento/hc-evento';
import {HcLogado} from '../pages/sync/website-spot/components/hc-logado/hc-logado';
import {HcNotice} from '../pages/sync/website-spot/components/hc-notice/hc-notice';
import {HcPhoto} from '../pages/sync/website-spot/components/hc-photo/hc-photo';
import {HcVideo} from '../pages/sync/website-spot/components/hc-video/hc-video';
import {HcMusic} from '../pages/sync/website-spot/components/hc-music/hc-music';
import {HcMusical} from '../pages/sync/website-spot/components/hc-musical/hc-musical';
import {HcMeritum} from '../pages/sync/website-spot/components/hc-meritum/hc-meritum';
import {HcHotlove} from '../pages/sync/website-spot/components/hc-hotlove/hc-hotlove';
import {HcFriendy} from '../pages/sync/website-spot/components/hc-friendy/hc-friendy';
import {HcUsuario} from '../pages/sync/website-spot/components/hc-usuario/hc-usuario';
import {HsTemplate} from '../pages/sync/website-spot/components/hs-template/hs-template';

import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {MatDatepickerModule, MatFormFieldModule, MatNativeDateModule, MatInputModule} from '@angular/material';
import {DragulaModule} from "ng2-dragula";
import {ColorSketchModule} from "ngx-color/sketch";
import {SuperTabsModule} from "ionic2-super-tabs";

//import {CONFIG} from "./config";

//https://github.com/angular/angular-cli/issues/13734
//FATAL ERROR: Ineffective mark-compacts near heap limit Allocation failed - JavaScript heap out of memory


/** USADO PELO PLUGIN PLUGIN-IONIC **/
/** ****************************** **/
@Injectable()
@Injectable()

export class MyErrorHandler implements ErrorHandler {

    ionicErrorHandler: IonicErrorHandler;

    constructor(injector: Injector, private platform: Platform) {

        try {

            this.ionicErrorHandler = injector.get(IonicErrorHandler);

        } catch (e) {
            // Unable to get the IonicErrorHandler provider, ensure
            // IonicErrorHandler has been added to the providers list below
        }

    }

    handleError(erro: any): void {

        if (this.platform.is('cordova')) {

            // todo: BRIDGE - Se quiser enviar erros para Bridge, Enviar por aqui.
            // RequestBridge...

            Pro.monitoring.handleNewError(erro);
            // Remove this if you want to disable Ionic's auto exception handling
            // in development mode.

        }

        this.ionicErrorHandler && this.ionicErrorHandler.handleError(erro);

    }
}

/** ****************************** **/
/** USADO PELO PLUGIN PLUGIN-IONIC **/


@NgModule({
    declarations: [
        TabMenu,
        AppConvite,
        AppTeclado,
        ContentDrawer,
        DragButton,
        Backfull,
        AppFeedback,
        Loading,
        CanalText,
        ImageScroll,
        AppPayout,
        AppMeritum,
        AppPlastic,
        Webster,
        TimePicker,
        DatePicker,
        Player,
        Searched,
        SpotusAnime,
        
        // Hotspot-Component
        CpBlocki,
        CpButton,
        CpEntire,
        CpValued,
        CpHeader,
        CpGround,

        CpHistory,
        CpLogotipo,

        // Hotspot-Template
        HcAction,
        HcAddress,
        HcBanner,
        HcSocial,
        HcCheckin,
        HcBirthday,
        HcBranded,
        HcDelivery,
        HcVoucher,
        HcEvento,
        HcLogado,
        HcNotice,
        HcPhoto,
        HcVideo,
        HcMusic,
        HcMusical,
        HcMeritum,
        HcHotlove,
        HcFriendy,
        HcUsuario,
        HsTemplate,

        BadgeDirective,
        BlinkBgDirective,
        BlscrollDirective,
        BrMaskDirective, // ## NAO ESTA USANDO ## //
        ConviteHoverDirective, // ## NAO ESTA USANDO ## //
        CorbackDirective,
        CormainDirective,
        DebouncedDirective,
        DelayIonChangeDirective,
        HideHeaderDirective,
        HotkeyDirective,
        KeyboardAttachDirective,
        ModalMarginDirective,
        MolderDirective,
        OverslideDirective,
        RequestButtonDirective,
        TextareaAutoresizeDirective,
        VerMaisDirective,
        WebsterDirective,
        WriterDirective,

        BarcodePipe,
        CurrencyPipe,
        DatenewPipe,
        DatetimePipe,
        HourtimePipe,
        DinheiroPipe,
        NumericoPipe,
        AbsolutePipe,
        PorcentaPipe,
        FilterFieldPipe,
        FilterIndexPipe,
        FilterValuePipe,

        HandappMain,

        TabsPage,

        ShowbookPage,
        ShowopenPage,
        ShowsyncPage,
        ShowdeskPage,
        ShowfilaPage,
        ShowtalkPage,
        ShowhourPage,
        ShowtimePage,
        ShowviewPage,
        ShowviewAtracaoPage,
        ShowviewListaPage,

        LoadingErroPage,

        PrivacyMenuPage,
        ProfileAuthPage,
        ProfileMenuPage,
        ProfileFotoPage,
        ProfilePagePage,
        ProfileBornPage,
        ProfileShipPage,
        MedalhaMenuPage,

        FriendyMenuPage,
        VisitorMenuPage,
        CentralMenuPage,
        ContatoMenuPage,
        AddressMenuPage,
        AccountMenuPage,
        EmissorMenuPage,
        DevelopMenuPage,
        ConexaoMenuPage,

        CheckinMenuPage,
        EntrakiOpenPage,
        RolezinMenuPage,
        PublicoMenuPage,
        
        MachineMenuPage,

        MonitorDeskPage,
        RegeditMenuPage,
        DesktopMenuPage,
        
        LancakiMenuPage,
        ConsumoSalePage,
        ConsumoEditPage,
        ContabyMenuPage,
        ChavecoMenuPage,
        SupportMenuPage,

        NegocioMenuPage,
        WebstorOpenPage,
        WebstorMenuPage,
        SettingMenuPage,
        ClusterMenuPage,
        BrandedMenuPage,
        BrandedHtmlPage,
        BlendedMenuPage,
        GateweyMenuPage,
        MeritumMenuPage,

        HotspotMenuPage,
        HotspotWorkPage,
        HotspotMarkPage,
        HotspotLovePage,

        GeradorMenuPage,
        FinanceMenuPage,
        InvoiceMenuPage,
        PaybookFindPage,
        PaybookMenuPage,
        PaybookCartPage,
        ParcelaMenuPage,
        PaymentMenuPage,
        MethodoMenuPage,
        RepasseMenuPage,
        PlasticMenuPage,
        CashierMenuPage,
        ProdutoMenuPage,
        ProdutoViewPage,
        RetirarMenuPage,

        WorkdayCodePage,
        SpotdayListPage,
        SpotdayInfoPage,
        SpotdayViewPage,
        ConviteMenuPage,

        UnidadeMenuPage,
        UsuarioMenuPage,
        GaleriaMenuPage,

        VoucherInfoPage,

        ModalActionPage,
        ModalFieldPage,
        ListingMenuPage,

        WebsiteSpotPage,
        WebsiteOlhaPage,
        WebstorSetaPage,
        WebstorEventoTipoPage,
        WarningMenuPage,

    ],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,

        MatDatepickerModule,
        MatNativeDateModule,
        MatFormFieldModule,
        MatInputModule,
        ColorSketchModule,

        //NgxMaterialTimepickerModule.forRoot(),

        SuperTabsModule.forRoot(),
        IonicModule.forRoot(HandappMain, {

            //keyboard.disableScroll
            scrollAssist: false, autoFocusAssist: false,

            platforms: {
                ios: {
                    backButtonText: 'Voltar'
                }

            },

            mode: 'ios'
        }),

        IonicStorageModule.forRoot({
            name: 'LoreanSync',
            //driverOrder: ['sqlite', 'indexeddb', 'websql']
            driverOrder: ['indexeddb', 'sqlite', 'websql']
        }),

        DragulaModule.forRoot(),

        HttpClientModule,
        FroalaEditorModule.forRoot(),
        FroalaViewModule.forRoot(),
        ImageCropperModule,
        FacebookModule.forRoot(),
        DeviceDetectorModule.forRoot(),
        YoutubePlayerModule,
        BrMaskerModule,
        RoundProgressModule,
    ],
    bootstrap: [IonicApp],
    entryComponents: [

        HandappMain,

        TabsPage,

        ShowbookPage,
        ShowopenPage,
        ShowsyncPage,
        ShowdeskPage,
        ShowfilaPage,
        ShowtalkPage,
        ShowhourPage,
        ShowtimePage,
        ShowviewPage,
        ShowviewAtracaoPage,
        ShowviewListaPage,

        LoadingErroPage,

        PrivacyMenuPage,
        ProfileAuthPage,
        ProfileMenuPage,
        ProfileFotoPage,
        ProfilePagePage,
        ProfileBornPage,
        ProfileShipPage,
        MedalhaMenuPage,

        FriendyMenuPage,
        VisitorMenuPage,
        CentralMenuPage,
        ContatoMenuPage,
        AddressMenuPage,
        AccountMenuPage,
        EmissorMenuPage,
        DevelopMenuPage,
        ConexaoMenuPage,

        CheckinMenuPage,
        EntrakiOpenPage,
        RolezinMenuPage,
        PublicoMenuPage,
        
        MachineMenuPage,

        MonitorDeskPage,
        RegeditMenuPage,
        DesktopMenuPage,
        
        LancakiMenuPage,
        ConsumoSalePage,
        ConsumoEditPage,
        ContabyMenuPage,
        ChavecoMenuPage,
        SupportMenuPage,

        NegocioMenuPage,
        WebstorOpenPage,
        WebstorMenuPage,
        SettingMenuPage,
        ClusterMenuPage,
        BrandedMenuPage,
        BrandedHtmlPage,
        BlendedMenuPage,
        GateweyMenuPage,
        MeritumMenuPage,

        HotspotMenuPage,
        HotspotWorkPage,
        HotspotMarkPage,
        HotspotLovePage,

        GeradorMenuPage,
        FinanceMenuPage,
        InvoiceMenuPage,
        PaybookFindPage,
        PaybookMenuPage,
        PaybookCartPage,
        ParcelaMenuPage,
        PaymentMenuPage,
        MethodoMenuPage,
        RepasseMenuPage,
        PlasticMenuPage,
        CashierMenuPage,
        ProdutoMenuPage,
        ProdutoViewPage,
        RetirarMenuPage,

        WorkdayCodePage,
        SpotdayListPage,
        SpotdayInfoPage,
        SpotdayViewPage,
        ConviteMenuPage,

        UnidadeMenuPage,
        UsuarioMenuPage,
        GaleriaMenuPage,

        VoucherInfoPage,

        ModalActionPage,
        ModalFieldPage,
        ListingMenuPage,

        WebsiteSpotPage,
        WebsiteOlhaPage,
        WebstorSetaPage,
        WebstorEventoTipoPage,
        WarningMenuPage,

        Webster

    ],
    providers: [

        Device,
        Push,
        Facebook,

        Camera,
        NFC,
        Ndef,
        File,
        FileTransferObject,
        WebIntent,
        InAppBrowser,
        ImagePicker,
        Vibration,
        TapticEngine,
        Contacts,
        CallNumber,
        NetworkInterface,
        LaunchNavigator,
        BarcodeScanner,
        WheelSelector,
        Clipboard,
        SocialSharing,

        YoutubeVideoPlayer,
        Deeplinks,

        ScreenOrientation,
        Keyboard,
        Geolocation,
        OpenNativeSettings,

        Util,

        DataService,
        GeolocationService,
        PushService,
        MessageService,
        StorageService,
        LogadoService,
        CarbookService,

        NavRepository,

        AppVersion,
        StatusBar,
        SplashScreen,

        HttpService,

        {
            provide: HTTP_INTERCEPTORS,
            useClass: BridgeInterceptor,
            multi: true,
        },

        /* USADO PELO PLUGIN PLUGIN-IONIC - Trocado pela chave abaixo!
        {
            provide: ErrorHandler,
            useClass: IonicErrorHandler
        },
        */

        /* USADO PELO PLUGIN PLUGIN-IONIC */
        IonicErrorHandler,
        [{provide: ErrorHandler, useClass: MyErrorHandler}]

        /*
        {
            provide: HttpService,
            useFactory: httpServiceCreator,
            deps: [HttpClient]
        }
        */

        /*
        {
            provide: HttpClient,
            useFactory: HttpService
        },
        */

        //*/
    ]
})

export class AppModule {

    constructor(platform: Platform) {


        /** USADO PELO PLUGIN PLUGIN-IONIC **/
        /** ****************************** **/
        if (platform.is('cordova')) {

            //Pro.init('8ef69d93', {appVersion: CONFIG.data.version});  //Kairus.Lorean
            //Pro.init('1c94c73e', {appVersion: CONFIG.data.version});  //lorean.theweek

        }


    }

}



// WEBPACK FOOTER //
// ./src/app/app.module.ts